import { AbstractRouterFilter } from '@zk/framework-vue';
import microApps from '@/router/microApps';

export default class NotFoundFilter extends AbstractRouterFilter {
  matches(to) {
    return !to.name;
  }

  order() {
    return super.order() + 2;
  }

  onBefore(to) {
    const isMicroApp = microApps.some(app => {
      const { activeRule } = app;
      const rules = Array.isArray(activeRule) ? [ ...activeRule ] : [activeRule];
      return rules.some(rule => {
        if (typeof rule === 'function') {
          return rule(to.fullPath);
        }
        return to.fullPath.startsWith(`${rule}`);
      });
    });
    if (isMicroApp) {
      return true;
    }
    return { name: '404' };
  }
}
